import React from 'react';
import Loader from '../../../components/Common/Loader';
import PlanPurchase from '../../../components/Common/PlanPurchase';
import { TeacherOnboardingStatusEnum, UserModel, UserRoleEnum, UserStatusEnum } from '../../../interfaces/user.interface';
import AccountVerfication from './AccountVerification';
import BuilderInit from './BuilderInit';
import StepKickStart from './StepKickStart';

interface UserActionSectionProps {
  user: UserModel | null;
  planSubscribed: boolean;
  loaders: {
    planExist: boolean;
  };
  showLogin: boolean;
  signUpStep: number;
  setSignUpStep: React.Dispatch<React.SetStateAction<number>>;
  paramPlan: string;
  startStepOne: (loader?: any) => void;
  setLoaders: React.Dispatch<React.SetStateAction<any>>;
  setShowThanksNote: React.Dispatch<React.SetStateAction<boolean>>;
  setPlanSubscribed: React.Dispatch<React.SetStateAction<boolean>>;
}

const UserActionSection: React.FC<UserActionSectionProps> = ({
  user,
  planSubscribed,
  loaders,
  showLogin,
  signUpStep,
  setSignUpStep,
  paramPlan,
  startStepOne,
  setLoaders,
  setShowThanksNote,
  setPlanSubscribed,
}) => {
  const isTeacherOnboarding =
    user?.role === UserRoleEnum.teacher &&
    user?.teacherOnboardingStatus === TeacherOnboardingStatusEnum.BookOnboarding;

  return (
    <div className="text-left mb-8 text-base text-storyblue">
      <div className="grid grid-cols-1 items-center md:grid-cols-2 gap-4 mt-4">
        {user && user.status === UserStatusEnum.ACTIVE ? (
          planSubscribed || !user?.verified ? (
            <div className="flex items-center p-[1rem]">
              <div>
                {user && !!user?.verified && (user?.plan !== null || user?.isTrialFreeAccess === true) ? (
                  <StepKickStart startStepOne={startStepOne} user={user} />
                ) : !user?.verified ? (
                  <AccountVerfication setLoaders={setLoaders} loaders={loaders} />
                ) : (
                  <PlanPurchase setShowThanksNote={setShowThanksNote} setPlanSubscribed={setPlanSubscribed} />
                )}
              </div>
            </div>
          ) : loaders.planExist ? (
            <div className="flex justify-center items-center">
              <Loader loader={loaders.planExist} />
            </div>
          ) : (
            <>
              <div className="flex justify-center items-center">
                <Loader loader={true} />
              </div>
            </>
          )
        ) : (
          <BuilderInit />
        )}
        <div>
          <img
            className=" animate__animated animate__rubberBand mx-auto max-w-[80%] shadow-2xl"
            src={isTeacherOnboarding ? '/celebration-image.png' : '/bookcover.png'}
            alt={isTeacherOnboarding ? 'Classroom celebration' : 'Book Cover'}
          />
          {isTeacherOnboarding && (
            <p className="mt-3 mx-auto max-w-[80%] text-sm md:text-base italic text-storyblue/80">
              &quot;So easy to implement and fold right into my curriculum. The books turned out great, and parents were
              so pleased&quot;
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserActionSection;
